var map = {
	"./1.png": 1463,
	"./1_black.png": 8630,
	"./2.png": 2654,
	"./2_black.png": 5463,
	"./3.png": 4694,
	"./3_black.png": 6520,
	"./4.png": 9781,
	"./4_black.png": 3193
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2505;